/** Update document favicon from site_settings URL (replaces default /vite.svg when set). */

function guessFaviconMime(url) {
  const u = String(url || '').toLowerCase().split('?')[0];
  if (u.endsWith('.svg')) return 'image/svg+xml';
  if (u.endsWith('.png')) return 'image/png';
  if (u.endsWith('.webp')) return 'image/webp';
  if (u.endsWith('.ico')) return 'image/x-icon';
  if (u.endsWith('.gif')) return 'image/gif';
  if (u.endsWith('.jpg') || u.endsWith('.jpeg')) return 'image/jpeg';
  return 'image/png';
}

function ensureLink(rel) {
  const head = document.head;
  if (!head) return null;
  let link = head.querySelector(`link[rel="${rel}"][data-inv-favicon]`);
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    link.setAttribute('data-inv-favicon', 'true');
    head.appendChild(link);
  }
  return link;
}

/**
 * @param {string} [url] — public URL from site_settings.site_favicon_url
 */
export function applySiteFavicon(url) {
  const href = String(url || '').trim();
  const head = document.head;
  if (!head) return;

  const iconLink =
    head.querySelector('link[rel="icon"][data-inv-favicon]') ||
    head.querySelector('link[rel="icon"]');

  if (!href) return;

  const link = iconLink || ensureLink('icon');
  if (!link) return;

  link.setAttribute('data-inv-favicon', 'true');
  link.href = href;
  link.type = guessFaviconMime(href);

  const apple = ensureLink('apple-touch-icon');
  if (apple) apple.href = href;
}
